import { useEffect, useRef } from "react";
import { useAppDispatch } from "./redux-store";
import { sendHeartbeat } from "./ducks/data/heartbeat";

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;
// Rapid tab switching shouldn't turn every "visible" event into a request.
const MIN_GAP_MS = 60 * 1000;

// Render-less component. Tells the server the user has the app open
// (users.last_active_at): once on mount, then every 5 minutes, but only
// while the tab is visible. Becoming visible again beats immediately.
const Heartbeat = () => {
  const dispatch = useAppDispatch();
  const lastSentAt = useRef(0);
  useEffect(() => {
    const beat = () => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastSentAt.current < MIN_GAP_MS) return;
      lastSentAt.current = Date.now();
      dispatch(sendHeartbeat());
    };
    beat();
    const interval = setInterval(beat, HEARTBEAT_INTERVAL_MS);
    document.addEventListener("visibilitychange", beat);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", beat);
    };
  }, [dispatch]);
  return null;
};

export default Heartbeat;
